export const catchIsUserValid = user => {
  // Dev deploy: the prod userId/userType claims are only stamped for the Auth0 LOCAL_TESTERS shim,
  // so an unshimmed account (e.g. a coowe.com Google login) would be treated as invalid and loop
  // back to sign-in. On dev, any authenticated Auth0 user is valid — the dev session is resolved
  // from the claim-or-email in verifyUserAndSave/devLogin.
  if (process.env.REACT_APP_API_ENDPOINT === "/api") {
    return !!user
  }
  return (
    !!user &&
    !!user["https://coo-e.com/userId"] &&
    !!user["https://coo-e.com/userType"]
  )
}
